import script from "./Nav.vue?vue&type=script&setup=true&lang=js"
export * from "./Nav.vue?vue&type=script&setup=true&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=2a921ceb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a921ceb"]])

export default __exports__